import { HELP_KEEP_MESSAGE } from '../../../facade/js/measureareaihm';
// import MeasureBarihm from '../../../facade/js/measurebarihm';

import FacadeMeasureihm from '../../../facade/js/measurebaseihm';
import FacadeMeasureLengthihm from '../../../facade/js/measurelengthihm';
import MeasureImplihm from './measurebaseihm';

/**
 * @classdesc
 * Main constructor of the class. Creates a MeasureAreaihm
 * control
 *
 * @constructor
 * @extends {M.impl.control.Measureihm}
 * @api stable
 */
export default class MeasureAreaihm extends MeasureImplihm {
  constructor() {
    super('Polygon');
    /**
     * Help message
     * @private
     * @type {string}
     */
    this.helpMsg_ = FacadeMeasureihm.HELP_MESSAGE;

    /**
     * Help message
     * @private
     * @type {string}
     */
    this.helpMsgContinue_ = HELP_KEEP_MESSAGE;

    this.name = 'MeasureAreaihm';
  }

  /**
   * This function add tooltip with extent of the area
   * @public
   * @param {ol.geom.SimpleGeometry} geometry - Object geometry
   * @return {string} output - Indicate the extent of the area
   * @api stable
   */
  formatGeometry(geometry) {
    const output = [];
    const plugins = this.facadeMap_.getPlugins().filter((plugin) => {
      return plugin.name === 'measurebarihm';
    });
    const conf = plugins[0].getControls().filter((control) => {
      return (control.name === 'measureconfiguracionihm');
    })[0];

    const elemChecked = conf.getImpl().getChecked();
    let checkedrumbo = false;
    let checkedsegmento = false;
    let checkedsismedidas = false;

    elemChecked.forEach((elem) => {
      if (elem === 'rumbo') {
        checkedrumbo = true;
      }
      if (elem === 'segmento') {
        checkedsegmento = true;
      }
      if (elem === 'sismedidas') {
        checkedsismedidas = true;
      }
    });

    if (checkedrumbo) {
      // Medida rumbo de los tramos
      const unit = '°';
      const point = geometry.getCoordinates()[0];
      const totalpoints = [];
      const pointsLen = geometry.getCoordinates()[0].length;
      for (let i = 0; i < pointsLen; i += 1) {
        totalpoints.push(point[i]);
      }
      const from = totalpoints[pointsLen - 3];
      const to = totalpoints[pointsLen - 2];
      const heading = Math.atan2(to[1] - from[1], to[0] - from[0]);
      const mul = heading * 180;
      const dividir = mul / Math.PI;
      let bearing = 90 - dividir;
      if (bearing < 0) {
        bearing += 360;
      }
      // let bearing = 90 - heading * 180 / Math.PI;
      const rumbo = Math.round(bearing * 10) / 10;
      output.push({ name: 'rumbo', valor: `${rumbo} ${unit}` });
    }
    if (checkedsegmento) {
      // medida en NM
      const unit = 'NM';
      const point = geometry.getCoordinates()[0];
      const totalpoints = [];
      const pointsLen = geometry.getCoordinates()[0].length;
      for (let i = 0; i < pointsLen; i += 1) {
        totalpoints.push(point[i]);
      }
      const from = totalpoints[pointsLen - 3];
      const to = totalpoints[pointsLen - 2];
      // init and act
      const from2 = totalpoints[0];
      const to2 = totalpoints[pointsLen - 2];
      const codeProj = this.facadeMap_.getProjection().code;
      if (!checkedsismedidas) {
        const line = ol.sphere.getDistance(ol.proj.transform(from, codeProj, 'EPSG:4326'), ol.proj.transform(to, codeProj, 'EPSG:4326'));
        const line2 = ol.sphere.getDistance(ol.proj.transform(from2, codeProj, 'EPSG:4326'), ol.proj.transform(to2, codeProj, 'EPSG:4326'));

        let length = Math.round(line * 100) / 100;
        let length2 = Math.round(line2 * 100) / 100;

        const inPerDisplayUnit = 72913.4252;
        const inPerMapUnit = 39.3701;
        length *= (inPerMapUnit / inPerDisplayUnit);
        length2 *= (inPerMapUnit / inPerDisplayUnit);
        const fmtlength = `${this.formatNumber(Math.round(length * 10) / 10)} ${unit}`;
        const fmtlength2 = `${this.formatNumber(Math.round(length2 * 10) / 10)} ${unit}`;
        output.push({ name: 'segmento', valor: fmtlength, left: fmtlength2 });
      } else {
        let length = null;
        length = ol.sphere.getDistance(ol.proj.transform(from, codeProj, 'EPSG:4326'), ol.proj.transform(to, codeProj, 'EPSG:4326'));
        const length2 = ol.sphere.getDistance(ol.proj.transform(from2, codeProj, 'EPSG:4326'), ol.proj.transform(to2, codeProj, 'EPSG:4326'));
        const obj = {};
        if (length > 1000) {
          obj.name = 'KM';
          obj.valor = `${this.formatNumber(Math.round(((length / 1000) * 100)) / 100)} km`;
        } else {
          obj.name = 'KM';
          obj.valor = `${this.formatNumber(Math.round(length * 100) / 100)} m`;
        }

        if (length2 > 1000) {
          obj.left = `${this.formatNumber(Math.round(((length2 / 1000) * 100)) / 100)} km`;
        } else {
          obj.left = `${this.formatNumber(Math.round(length2 * 100) / 100)} m`;
        }
        output.push(obj);
      }
    }
    if (checkedsismedidas) {
      // distancia
      let length = null;
      const codeProj = this.facadeMap_.getProjection().code;
      if (codeProj === 'EPSG:3857') {
        length = Math.round(ol.sphere.getLength(geometry) * 100) / 100;
      }
      if (length > 1000) {
        output.push({ name: 'KM', valor: `${this.formatNumber(Math.round(((length / 1000) * 100)) / 100)} km` });
      } else {
        output.push({ name: 'KM', valor: `${this.formatNumber(Math.round(length * 100) / 100)} m` });
      }
      // area
      let area = null;
      const projection = this.facadeMap_.getProjection();
      area = ol.sphere.getArea(geometry, { projection: projection.code });
      if (area <= 10000) {
        output.push({ name: 'KM', valor: `${this.formatNumber(Math.round(area * 100) / 100)} m<sup>2</sup>` });
      } else if (area > 10000 && area <= 1000000) {
        output.push({ name: 'KM', valor: `${this.formatNumber((Math.round((area / 10000) * 10000) / 10000))} ha` });
      } else if (area > 1000000) {
        output.push({ name: 'KM', valor: `${this.formatNumber((Math.round((area / 1000000) * 10000) / 10000))} km<sup>2</sup>` });
      }
    }

    if (!checkedsismedidas) {
      // distancia medida en NM
      const unitlength = 'NM';
      let length = Math.round(ol.sphere.getLength(geometry) * 100) / 100;
      const inPerDisplayUnitlength = 72913.4252;
      const inPerMapUnitlength = 39.3701;
      length *= (inPerMapUnitlength / inPerDisplayUnitlength);
      output.push({ name: 'NM', valor: `${this.formatNumber(Math.round(length * 10) / 10)} ${unitlength}` });
      // area en NM
      const unitarea = 'NM';
      const elevado = '<sup>2</sup>';
      const projection = this.facadeMap_.getProjection();
      let area = ol.sphere.getArea(geometry, { projection: projection.code });
      const inPerDisplayUnitarea = 72913.4252;
      const inPerMapUnitarea = 39.3701;
      area *= (inPerMapUnitarea / inPerDisplayUnitarea) ** 2;
      output.push({ name: 'NM', valor: `${this.formatNumber(Math.round(area * 10) / 10)} ${unitarea}${elevado}` });
    }


    return output;
  }

  /**
   * This function returns coordinates to tooltip
   * @public
   * @param {ol.geom.Geometry} geometry - Object geometry
   * @return {array} coordinates to tooltip
   * @api stable
   */
  getTooltipCoordinate(geometry) {
    return geometry.getInteriorPoint().getCoordinates();
  }

  activate() {
    const measureLength = this.facadeMap_.getControls().filter((control) => {
      return (control instanceof FacadeMeasureLengthihm);
    })[0];

    if (measureLength) {
      measureLength.deactivate();
    }

    super.activate();
  }

  /* eslint-disable newline-per-chained-call */
  formatNumber(number) {
    return `${number}`.replace(/\d(?=(\d{3})+\.)/g, '$&*').split('.').join(',').split('*').join('.');
  }
}
